import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableStar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_3658_102188)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0.575306 6.40316C0.565899 6.39414 0.56225 6.38631 0.560291 6.378C0.557823 6.36754 0.557725 6.35324 0.562186 6.33826C0.566665 6.32323 0.573406 6.31512 0.576235 6.3125C0.576334 6.31241 0.576422 6.31232 0.576511 6.31223C0.577168 6.31154 0.577839 6.31085 0.582857 6.31014L0.58359 6.31004L5.48159 5.61404L5.74 5.57732L5.85761 5.34431L8.04154 1.01745C8.04558 1.00946 8.04898 1.00532 8.05065 1.00352C8.05236 1.00167 8.05347 1.00095 8.05391 1.00068C8.05482 1.00013 8.05637 0.999512 8.05875 0.999512C8.06112 0.999512 8.06268 1.00013 8.06358 1.00068C8.06402 1.00094 8.06513 1.00167 8.06685 1.00352C8.06851 1.00532 8.07192 1.00946 8.07595 1.01745L10.2599 5.34431L10.3775 5.57732L10.6359 5.61404L15.5339 6.31004L15.5346 6.31014C15.5397 6.31085 15.5403 6.31154 15.5409 6.3122C15.541 6.31229 15.5411 6.31238 15.5412 6.31246C15.544 6.31504 15.5507 6.32307 15.5551 6.33797C15.5595 6.35282 15.5594 6.36698 15.5569 6.37735C15.555 6.38559 15.5513 6.39354 15.5416 6.40279L15.5413 6.40303L12.0193 9.75903L11.8255 9.94372L11.8718 10.2074L12.7018 14.9374L12.7018 14.9377C12.7052 14.9567 12.7024 14.9681 12.6996 14.975C12.6963 14.9835 12.6907 14.9907 12.6846 14.9956C12.6822 14.9975 12.6803 14.9986 12.6789 14.9993C12.6783 14.999 12.6775 14.9986 12.6765 14.9982C12.6765 14.9982 12.6765 14.9981 12.6765 14.9981L8.28574 12.7423L8.05717 12.6248L7.82863 12.7423L3.44104 14.9981C3.44096 14.9982 3.44088 14.9982 3.4408 14.9983C3.43994 14.9987 3.4392 14.999 3.43857 14.9993C3.43722 14.9986 3.4353 14.9975 3.43294 14.9956C3.42677 14.9907 3.42119 14.9835 3.41785 14.975C3.41512 14.9681 3.41233 14.9567 3.41567 14.9377L3.41572 14.9374L4.24572 10.2074L4.292 9.94368L4.09812 9.75898L0.575459 6.40331C0.575408 6.40326 0.575357 6.40321 0.575306 6.40316Z",
				stroke: "current"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3658_102188",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white",
				transform: "translate(0.0585938)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgTableStar);
export { ForwardRef as ReactComponent };
